module.exports = __webpack_public_path__ + "img/ag.a801d50a.png";